import { useIdStringFilter } from "shared-ts/hooks/useFilter"

import { useListPricingTiersForCompanyQuery } from "features/api/company"
import { useWebFilter } from "hooks/filters/useWebFilter"

export const tierFilterKey = "tiers"

export function useTierFilter() {
  const { data } = useListPricingTiersForCompanyQuery({})

  const { filter, selectedKeys: selectedTierIdStrings } = useIdStringFilter({
    key: tierFilterKey,
    label: "Tier",
    values: data?.tiers ?? [],
    sort: (a, b) => a.rank - b.rank,
    labelExtractor: (t) => t.name,
    autoFilterOptions: true,
    useFilter: useWebFilter,
  })

  return { filter, selectedTierIdStrings }
}
